module.exports = __webpack_public_path__ + "static/media/world-icon.8a5ae5b9.svg";